<template>
  <div id="load-order-loading" class="vs-con-loading__container">
    <div class="vx-row mt-5">
      <div class="vx-col md:w-1/3 mt-5 w-full">
        <div @click="setStatusFilter('2')" class="pointer">
          <statistics-card-line
            icon="MapPinIcon"
            icon-right
            :statistic="readyToLoad"
            statisticTitle="Ready to Load"
            :hideChart="true"
            color="info"
          />
        </div>
      </div>
      <div class="vx-col md:w-1/3 mt-5 w-full">
        <div @click="setStatusFilter('3')" class="pointer">
          <statistics-card-line
            icon="MapPinIcon"
            icon-right
            :statistic="onLoad"
            statisticTitle="On Load"
            :hideChart="true"
            color="warning"
          />
        </div>
      </div>
      <div class="vx-col md:w-1/3 mt-5 w-full">
        <div @click="setStatusFilter('4')" class="pointer">
          <statistics-card-line
            icon="PackageIcon"
            icon-right
            :statistic="shipped"
            statisticTitle="Shipped"
            :hideChart="true"
            color="success"
          />
        </div>
      </div>
    </div>
    <div class="vx-row mt-5">
      <div class="vx-col w-full mt-5">
        <vs-card>
          <load-order-table
            :data="list"
            @search="handleSearch"
            @loadMore="loadMore"
            @add="$router.push('/load_orders/create').catch(() => {})"
          />
        </vs-card>
      </div>
    </div>
  </div>
</template>

<script>
import LoadOrderTable from './components/LoadOrderTable.vue'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import loadOrder from '@/http/requests/loadOrder'
import loading from '@/mixins/Loading'
export default {
  components: {
    LoadOrderTable,
    StatisticsCardLine
  },
  computed: {
    isLoading() {
      return this.loading.data || this.loading.badget
    }
  },
  data: () => ({
    lastPage: '',
    params: {
      status_id: '2'
    },
    search: '',
    page: 1,
    clients: [],
    list: [],
    loading: {
      data: false,
      badget: false
    },
    onLoad: 0,
    readyToLoad: 0,
    shipped: 0
  }),
  methods: {
    getData() {
      this.loading.data = true
      const data = Object.assign({}, this.params)
      data.page = this.page
      data.search = this.search
      loadOrder
        .getList(data)
        .then((res) => {
          this.lastPage = res.data.last_page
          this.list = res.data.data
          this.loading.data = false
        })
        .catch((err) => {
          console.log(err)
          this.loading.data = false
        })
    },
    loadMore() {
      if (this.page >= this.lastPage) {
        return
      }
      this.page++
      this.getData()
    },
    getBadget() {
      this.loading.badget = true
      loadOrder
        .getBadget()
        .then((res) => {
          this.onLoad = res.data[0].total
          this.readyToLoad = res.data[1].total
          this.shipped = res.data[2].total
          this.loading.badget = false
        })
        .catch((err) => {
          console.log(err)
          this.loading.badget = false
        })
    },
    handleSearch(text) {
      this.search = text
      this.page = 1
      this.getData()
    },
    sort(e) {
      this.params.sortBy = e.sortBy
      this.params.sort = e.sort
      this.getData()
    },
    setStatusFilter(status) {
      this.params.status_id = status
      this.getData()
    }
  },
  mounted() {
    this.getData()
    this.getBadget()
  },
  mixins: [loading],
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading('load-order-loading')
      } else {
        this.closeLoading('load-order-loading')
      }
    }
  }
}
</script>

<style></style>
